import { useMemo } from 'react';

import { DocumentApplied, PendingAccount, Request } from '../types';

interface AmountCalculations {
  amountPendingAccounts: number;
  amountAppliedDocuments: number;
  totalToPay: number;
}

export const useAmountCalculations = (request: Request): AmountCalculations => {
  const amountPendingAccounts = useMemo(
    () =>
      request.pendingAccounts.reduce(
        (acc: number, account: PendingAccount) => acc + (account.amount || 0),
        0,
      ),
    [request.pendingAccounts],
  );

  const amountAppliedDocuments = useMemo(
    () =>
      request.documentsApplied.reduce(
        (acc: number, doc: DocumentApplied) => acc + (doc.amount || 0),
        0,
      ),
    [request.documentsApplied],
  );

  const totalToPay = amountPendingAccounts - amountAppliedDocuments;

  return {
    amountPendingAccounts,
    amountAppliedDocuments,
    totalToPay,
  };
};
